export enum SupportTripStatusEnum {
  A_APROVAR = "A Aprovar",
  APROVADO = "Aprovado",
  NAO_APROVADO = "Não Aprovado",
}
